import React from 'react';
import { a as _taggedTemplateLiteral } from './_rollupPluginBabelHelpers-53ddb3bb.js';
import styled, { css } from 'styled-components';

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    height: 0;\n    overflow: hidden;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledCollapsible = styled.div(_templateObject(), function (_ref) {
  var collapsed = _ref.collapsed;
  return collapsed && css(_templateObject2());
});

var Collapsible = function Collapsible(_ref) {
  var children = _ref.children,
      collapsed = _ref.collapsed,
      className = _ref.className;
  return React.createElement(StyledCollapsible, {
    collapsed: collapsed,
    className: className,
    "aria-expanded": !collapsed
  }, children);
};

Collapsible.defaultProps = {
  children: null,
  collapsed: false,
  className: null
};
Collapsible.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Collapsible",
  "props": {
    "children": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "node"
        }, {
          "name": "arrayOf",
          "value": {
            "name": "node"
          }
        }]
      },
      "required": false,
      "description": ""
    },
    "collapsed": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "className": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};
export default Collapsible;
export { Collapsible };